import { GlobalChatPanel } from "../components/chat/GlobalChatPanel";

export function ChatPage() {
  return (
    <div className="h-full flex flex-col">
      <h1 className="text-2xl font-bold text-gray-900 mb-4 shrink-0">Training Coach</h1>
      <div className="flex-1 min-h-0">
        <GlobalChatPanel />
      </div>
    </div>
  );
}
